// extracted by mini-css-extract-plugin
var _1 = "ActivityPopup_content__jsIn6";
var _2 = "ActivityPopup_header__V-3cY";
var _3 = "ActivityPopup_meta__9uokv";
var _4 = "ActivityPopup_metaUser__cx8SO";
var _5 = "ActivityPopup_wrapper__7EQfZ";
export { _1 as "content", _2 as "header", _3 as "meta", _4 as "metaUser", _5 as "wrapper" }
